import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Button, Tooltip, CircularProgress, Box } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import axios from 'axios';

import { URL } from '../../assets/js/constants'
import { toggleShowDialog } from '../../store/actions/dialog';
import { getNegocios, desativarNegocio } from '../../store/actions/negocio';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const Negocios = props => {
    const history = useHistory();
    const { negocios, toggleShowDialog, getNegocios, desativarNegocio, loading } = props
    const [toggleDesativarDialog, setToggleDesativarDialog] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    useEffect(() => {
        getNegocios();
    }, [])

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Nome',
            selector: (row) => row.nome,
            sortable: true,
        },
        {
            name: 'CPF/CNPJ',
            selector: (row) => row.cpfOuCnpj,
            width: '150px',
        },
        {
            name: 'Telefone',
            selector: (row) => row.telefonePrincipal,
            width: '150px',
        },
        {
            name: 'Contato',
            selector: (row) => row.contato,
            width: '130px',
        },
        {
            name: 'Plano',
            selector: (row) => row.planoDescricao,
            width: '100px',
        },
        {
            name: <>Stripe<br />Criado</>,
            center: 'true',
            selector: (row) => (
                row.stripeSellerAccountId
                    ?
                    <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon>
                    :
                    <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '90px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: <>Stripe<br />Ativo</>,
            center: 'true',
            selector: (row) => (
                row.stripePayoutsEnabled
                    ?
                    <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon>
                    :
                    <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '90px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: 'Ativo',
            center: 'true',
            selector: (row) => (
                row.ativo
                    ?
                    <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon>
                    :
                    <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '90px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Dados Loja' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarNegocio(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Adicionar/Editar Logotipo' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="logotipo" size='small' color='secondary' onClick={() => handleAddLogoNegocio(row.id)}><Icon>photo</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Criar Conta Stripe' placement='right'>
                        <IconButton style={{ padding: 1 }} disabled={row.stripeSellerAccountId} aria-label="stripe" size='small' color='secondary' onClick={() => handleCriarContaStripe(row.id)}><Icon>paid</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Enviar E-mail de Onboarding Stripe' placement='right'>
                        <IconButton style={{ padding: 1 }} disabled={row.stripePayoutsEnabled} aria-label="stripe" size='small' color='secondary' onClick={() => handleGerarUrlOnboardStripe(row.id)}><Icon>send</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Desativar Loja' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleDesativarNegocio(row)}><Icon>delete</Icon></IconButton>
                    </Tooltip>
                </>
            ),
            width: '130px',
        }
    ];

    const handleEditarNegocio = (id) => {
        history.push({
            pathname: '/lojas/editar-loja',
            state: {
                lojaId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleAddLogoNegocio = (id) => {
        history.push({
            pathname: '/lojas/logo-da-loja',
            state: {
                lojaId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleDesativarNegocio = (row) => {
        toggleShowDialog(row);
        setToggleDesativarDialog(true);
    }

    const handleCancelarDesativar = () => {
        setToggleDesativarDialog(false);
    }

    const handleCriarContaStripe = async (negocioId) => {
        // 1. Ativa o loading ANTES de iniciar a chamada à API
        setProcessingMessage('Comunicando com Stripe...');
        setIsProcessing(true);
        try {
            // 2. Faz a chamada ao backend Spring Boot
            const response = await axios.post(`${URL}/payment/v1/create-seller/${negocioId}`);

            // Sucesso!
            toastr.success('Sucesso!', 'Conta Stripe criada e URL enviada ao lojista.');

        } catch (error) {
            // Tratamento de erro
            toastr.error('Erro', 'Falha ao realizar cadastro na Stripe. Verifique os dados.');
        } finally {
            // 3. Desativa o loading SEMPRE, independente de sucesso ou erro, no bloco finally
            setIsProcessing(false);
        }
    }

    const handleGerarUrlOnboardStripe = async (negocioId) => {
        // 1. Ativa o loading ANTES de iniciar a chamada à API
        setProcessingMessage('Enviando e-mail...');
        setIsProcessing(true);
        try {
            // 2. Faz a chamada ao backend Spring Boot
            const response = await axios.post(`${URL}/payment/v1/send-email-onboarding-stripe/${negocioId}`);

            // Sucesso!
            toastr.success('Sucesso!', 'E-mail de integração Stripe enviado com sucesso.');

        } catch (error) {
            // Tratamento de erro
            toastr.error('Erro', 'Falha ao e-mail integração Stripe. Verifique.');
        } finally {
            // 3. Desativa o loading SEMPRE, independente de sucesso ou erro, no bloco finally
            setIsProcessing(false);
        }
    }

    const handleConfirmarDesativar = (idDialogShow) => {
        desativarNegocio(idDialogShow);
        setToggleDesativarDialog(false);
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Negócios' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={negocios}
                    visibleSearch={negocios && negocios.length > 0}
                    camposParaBusca={['nome', 'email', 'cpfOuCnpj', 'contato', 'planoDescricao']}

                />
                <Grid container >
                    <Button component={Link} variant='contained' color='secondary' to={{ pathname: '/lojas/cadastrar-loja', state: { from: window.location.pathname } }}>Cadastrar Loja</Button>
                </Grid>
            </Box>
            <DialogAlert
                title='Desativar Negócio'
                okButton={true}
                labelOkButton='Confirmar'
                okButtonClick={handleConfirmarDesativar}
                cancelButton={true}
                labelCancelButton='Cancelar'
                cancelButtonClick={handleCancelarDesativar}
                openDialog={toggleDesativarDialog}>
                Tem certeza que deseja desativar o negócio?
            </DialogAlert>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={processingMessage}
            />


        </>
    )
}

const mapStateToProps = state => (
    {
        negocios: state.negocio.negocios,
        idDialogShow: state.dialog.idDialogShow,
        loading: state.negocio.loading
    }
)

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        toggleShowDialog,
        getNegocios,
        desativarNegocio,
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Negocios)